import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import styles from "../../casinoComponents/videoBox/VideoBox.module.css";
import { VideoBoxTimer } from "../../casinoComponents/videoBox/overlays";
import { getCasinoRulesHtml } from "../../../data/casinoRulesHtml";
import { IS_REF_MOBILE } from "../../../utils/refViewport";

/**
 * `.casino-video` for the reference templates that mount <CasinoRules> as a SIBLING of the video
 * (Sic Bo, Sic Bo 2, Doli Dana) instead of inside it like the shared VideoBox does:
 *   .casino-video (video-box-container, [cards overlay], .casino-timer, rules (i) icon)
 *   " " <div> (in-video rules panel + rules modal) </div>
 * Returns a fragment; the page puts it right after the .game-header.
 */
export default function RefVideo({ iframeSrc, timerValue, rulesType, cardsOverlay = null }) {
  const [streamError, setStreamError] = useState(null);
  const [showRules, setShowRules] = useState(false);
  const [showRulesModal, setShowRulesModal] = useState(false);
  const iframeError = streamError?.src === iframeSrc;
  const handleIframeError = (message = "Video stream unavailable") => setStreamError({ src: iframeSrc, message });
  const rulesHtml = getCasinoRulesHtml(rulesType);

  const handleRulesClick = () => {
    if (!rulesHtml) return;
    setShowRules(true);
    // Reference: IS_MOBILE also opens the modal; closing it leaves the in-video panel open
    if (IS_REF_MOBILE) setShowRulesModal(true);
  };

  return (
    <>
      <div className="casino-video">
        <div className="video-box-container">
          <div className="video-box">
            {iframeError ? (
              <div className={styles.errorMessage}>
                <div>🎥</div>
                <div>{streamError.message}</div>
                <div style={{ fontSize: "0.9rem", marginTop: "0.5rem", opacity: 0.8 }}>
                  Please check your connection or try again later
                </div>
              </div>
            ) : (
              <iframe
                src={iframeSrc || undefined}
                title="Live Stream"
                allowFullScreen
                onError={() => handleIframeError()}
                onLoad={(e) => {
                  try {
                    const iframeDoc = e.target.contentDocument || e.target.contentWindow?.document;
                    if (iframeDoc?.body?.innerText?.includes("not allowed")) {
                      handleIframeError("Stream access not allowed");
                    }
                  } catch {
                    // cross-origin stream: nothing to inspect
                  }
                }}
              />
            )}
          </div>
        </div>{" "}
        {cardsOverlay}
        {cardsOverlay ? " " : null}
        <VideoBoxTimer timerValue={timerValue} />{" "}
        <div className="casino-video-right-icons">
          <div title="Rules" className="casino-video-rules-icon" onClick={handleRulesClick}>
            <i className="fas fa-info-circle" />
          </div>
        </div>
      </div>{" "}
      <div>
        {showRules && (
          <div
            id="casino-vieo-rules"
            aria-modal="true"
            className="casino-vieo-rules show d-none-small show-rules"
            style={{ display: "block" }}
          >
            <div className="rules-header">
              <div>Rules</div>{" "}
              <i className="fas fa-times" onClick={() => setShowRules(false)} />
            </div>{" "}
            <div className="rules-body" dangerouslySetInnerHTML={{ __html: rulesHtml }} />
          </div>
        )}
        <Modal
          show={showRulesModal}
          onHide={() => setShowRulesModal(false)}
          className="casino-rules teenpatti2-rule-modal"
          dialogClassName="modal-md"
          id="rules-modal"
        >
          <header className="modal-header">
            <h5 className="modal-title">Rules</h5>{" "}
            <button type="button" aria-label="Close" className="close" onClick={() => setShowRulesModal(false)}>
              ×
            </button>
          </header>
          <Modal.Body>
            <div className="casino-vieo-rules show-rules show">
              <div className="rules-body" dangerouslySetInnerHTML={{ __html: rulesHtml || "" }} />
            </div>
          </Modal.Body>
        </Modal>
      </div>
    </>
  );
}
